module.exports = __webpack_public_path__ + "static/SY-header-b4801170d130fa75b0f4d2f50f1b49de.png";